"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.today = today;
const fdate_1 = require("./fdate");
/**
 * dzisiejsza data w formacie yyyy-MM-dd
 */
function today() {
    return (0, fdate_1.fdate)(new Date());
}
//# sourceMappingURL=today.js.map